module.exports = __webpack_public_path__ + "static/media/icon-phone-blue.2ae78f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-phone-blue.svg
// module id = 1468
// module chunks = 0